const menuItems = (isLoggedIn, language = 'EN') => {
  const getTexts = () => {
    switch (language) {
      case 'TH':
        return {
          loginSignup: 'เข้าสู่ระบบ / สมัครสมาชิก',
          dashboard: 'แดชบอร์ด',
          qrScanner: 'สแกน QR Code',
          tvent: 'Travy (ทัวร์กลุ่ม)',
          eventAddingRequest: 'ขอเพิ่มข้อมูล',
          logout: 'ออกจากระบบ'
        };
      case 'CN':
        return {
          loginSignup: '登录 / 注册',
          dashboard: '仪表板',
          qrScanner: '扫描二维码',
          tvent: 'Travy（旅游团）',
          eventAddingRequest: '添加信息',
          logout: '退出登录'
        };
      default:
        return {
          loginSignup: 'Login / Sign Up',
          dashboard: 'Dashboard',
          qrScanner: 'Scan QR Code',
          tvent: 'Travy (Tour Group)',
          eventAddingRequest: 'Add Information',
          logout: 'Logout'
        };
    }
  };

  const texts = getTexts();

  return [
    isLoggedIn
      ? {
          label: texts.dashboard,
          path: '/dashboard',
          external: false,
          action: 'dashboard'
        }
      : {
          label: texts.loginSignup,
          path: '/login',
          external: false
        },
    {
      label: texts.qrScanner,
      path: '/qr-scanner',
      external: false
    },
    ...(isLoggedIn ? [{
      label: texts.tvent,
      path: '/tour-guide',
      external: false
    }] : []),
    {
      label: texts.eventAddingRequest,
      path: '/eventinput',
      external: false,
      action: 'add-data'
    },
    ...(isLoggedIn ? [{
      label: texts.logout,
      path: '/logout',
      external: false,
      action: 'logout'
    }] : [])
  ];
};

export default menuItems;
